import { DataGrid } from '@tableau/data-grid-1-wrapper';

import { DataGridCells } from '~commonInfra/components/dataGrid/DataGridCells';
import { ReactCheckboxTristate } from '~src/commonInfra/components/checkbox/ReactCheckboxTristate';
import { SiteRolePickerMenu } from '~src/userManagement/components/siteRolePicker/SiteRolePickerMenu';

import { Messages } from '../../codegen/Localize';
import { ISiteNameWithId } from '../serverApi/types/ISiteNameWithId';

export module SiteMembershipGridColumns {

  export function columns(
    dropdownProps: (site: ISiteNameWithId) => SiteRolePickerMenu.Props,
    checkboxProps: (site: ISiteNameWithId) => ReactCheckboxTristate.Props
  ): DataGrid.Column[] {

    const columns: DataGrid.Column[] = [
      {
        name: 'select-site-col',
        dataKey: '0',
        headerText: '',
        cellFormatter: DataGridCells.SiteGridCheckboxCell(checkboxProps),
        preferredWidth: 40,
        resizable: false,
        sortable: false,
      },
      {
        name: 'site-name-col',
        dataKey: '1',
        headerText: Messages.site(),
        cellFormatter: DataGridCells.PlainTextCell('name'),
        preferredWidth: 160,
        resizable: false,
        sortable: false
      },
      {
        name: 'site-select-col',
        dataKey: '2',
        headerText: Messages.siteRole(),
        cellFormatter: DataGridCells.SiteGridDropdownCell(dropdownProps, checkboxProps),
        growToFit: true,
        resizable: false,
        sortable: false
      }];
    return columns;
  }
}
